import { allModelsSelector } from 'common-src/utils/selectorUtils';

import { ExamStatus } from './constants';

export const getPatientRoutineExams = (state, patientId) =>
  allModelsSelector(
    state,
    'PatientRoutineExam',
    (pre) => pre.patientId === patientId && !pre.deletedAt,
  ).sort((a, b) => new Date(b.dateCompleted) - new Date(a.dateCompleted));

export const getMostRecentPatientRoutineExams = (state, patientId) => {
  const exams = allModelsSelector(
    state,
    'PatientRoutineExam',
    (pre) => pre.patientId === patientId && !pre.deletedAt,
  );

  const hasYesStatusByType = exams.reduce((acc, exam) => {
    const { type, detail, status } = exam;
    if (status === ExamStatus.Yes) {
      acc[`${type}-${detail}`] = true;
    }
    return acc;
  }, {});

  const latestExamsByTypeAndDetail = Object.values(
    exams.reduce((acc, exam) => {
      const { type, detail, dateCompleted, status } = exam;
      const key = `${type}-${detail}`;
      const shouldSkip = status === ExamStatus.NoScheduled && hasYesStatusByType[key];

      if (
        (!acc[key] || new Date(dateCompleted) > new Date(acc[key].dateCompleted)) &&
        !shouldSkip
      ) {
        acc[key] = exam;
      }

      return acc;
    }, {}),
  );

  return latestExamsByTypeAndDetail;
};

export const getLastUpdatedPatientRoutineExamDate = (state, patientId) => {
  const exams = allModelsSelector(
    state,
    'PatientRoutineExam',
    (pre) => pre.patientId === patientId,
  ).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

  return exams[0]?.updatedAt;
};
